import React from 'react';
import { Volleyball } from 'lucide-react';

// Shared auth shell for login/register pages.
const LayoutAuth = ({ children, title, subtitle }) => (
  <div className="min-h-screen bg-beachvision-bg text-white relative overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-16 -left-20 h-56 w-56 rounded-full bg-beachvision-coral/20 blur-3xl" />
      <div className="absolute top-20 -right-20 h-64 w-64 rounded-full bg-beachvision-teal/20 blur-3xl" />
    </div>

    <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-beachvision-shell flex-col justify-center px-4 py-8">
      <div className="mb-8 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-beachvision-coral/20 ring-1 ring-beachvision-coral/40">
          <Volleyball className="h-7 w-7 text-beachvision-coral" />
        </div>
        <p className="text-xs font-display font-bold uppercase tracking-[0.2em] text-beachvision-teal">
          Beachvision
        </p>
        <h1 className="mt-3 font-display text-3xl font-black tracking-tight text-beachvision-primary-light">
          {title}
        </h1>
        {subtitle ? (
          <p className="mx-auto mt-2 max-w-sm text-sm text-beachvision-muted">
            {subtitle}
          </p>
        ) : (
          ''
        )}
      </div>

      <div className="rounded-3xl bg-beachvision-surface-low/95 p-6 shadow-2xl shadow-black/30 ring-1 ring-white/5">
        {children}
      </div>
    </div>
  </div>
);

export default LayoutAuth;

